export const EditorKeys = {
  easy: 'tiptap',
  code: 'prism',
}
